<template>
  <div class="row">
    <div class="col-md-12">
      <select class="form-control" v-model="content" @change="handleInput">
      <option :value="null">Type d'activité</option>
        <optgroup label="Eté">
            <option value="randonnée">Randonnée</option>
            <option value="canyoning">Canyoning</option>
            <option value="via ferrata">Via ferrata</option>
            <option value="escalade">Escalade</option>
            <option value="alpinisme">Alpinisme</option>
            <option value="spéléologie">Spéléologie</option>
            <option value="vtt">VTT</option>
            <option value="marche nordique">Marche nordique</option>
            <option value="parapente">Parapente</option>
            <option value="randonnée Âne">Randonnée Âne</option>
        </optgroup>
        <optgroup label="Hiver">
            <option value="ski de randonnée">Ski de randonnée</option>
            <option value="ski hors piste / freeride">Ski hors piste / freeride</option>
            <option value="ski sur piste">Ski sur piste</option>
            <option value="ski nordique">Ski nordique</option>
            <option value="héliski">Héliski</option>
            <option value="raquette">Raquette</option>
            <option value="cascade de glace">Cascade de glace</option>
            <option value="Raid à ski">Raid à ski</option>
        </optgroup>
        <optgroup label="Multi saisons">
            <option value="trail">Trail</option>
            <option value="PreparationAthletique">Préparation athlétique</option>
            <option value="marcheNordique">Marche nordique</option>
            <option value="triathlon">Triathlon</option>
        </optgroup>
        <optgroup label="Experiences">
            <option value="sur mesure">Sur mesure</option>
            <option value="toute saison">Toute saison</option>
            <option value="nuit en refuge">Nuit en refuge</option>
            <option value="voyage">Voyage</option>
            <option value="séminaire">Séminaire</option>
        </optgroup>
      </select>
    </div>
  </div>
</template>

<script>
export default {

  name: 'tariffSelect',
  props:{
    value: {
      default: ''
    }
  },
  data () {
    return {
      content: this.value
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.content = newVal
    }
  },
  methods: {
    handleInput (e) {
        this.$emit('input', this.content)
    },
  }
};
</script>

<style lang="css" scoped>

</style>
